import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { TranslationFile } from 'i18n'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MspDispatchContext, MSP_ACTIONS } from 'components/multistep/Multistep'
import { getLanguageLocale } from 'utils/countryHelpers'

const ApplicationDataViewUk = () => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
	])
	const { loanApplication } = useContext(ApplicationDispatchContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [showModal, setShowModal] = useState(false)

	const applicationData = loanApplication.applicationData

	const handleEditConfirm = () => {
		setShowModal(false)
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: { index: msp.index + 1 },
		})
		dispatchMsp({
			type: MSP_ACTIONS.SET_PROGRESS_BAR_INDEX,
			payload: { progressBarIndex: msp.progressBarIndex + 1 },
		})
	}

	const handleContinue = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: { index: msp.index + 2 },
		})
		dispatchMsp({
			type: MSP_ACTIONS.SET_PROGRESS_BAR_INDEX,
			payload: { progressBarIndex: msp.progressBarIndex + 2 },
		})
	}

	return (
		<div className="application-data-view-uk">
			<div>
				<p>{t('ApplicationDataViewDescrition')}</p>
			</div>
			<div className="row">
				<div className="data-section col-12 col-md-6 mb-4">
					<h4>{t('PersonalInformationHeader')}</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('FirstName', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.firstName}
						</dd>

						<dt className="col-sm-5">
							{t('LastName', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.lastName}
						</dd>

						<dt className="col-sm-5">
							{t('BirthDate', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.birthDate
								? new Date(
										applicationData?.personalInfo
											?.birthDate!,
									).toLocaleDateString(getLanguageLocale())
								: ''}
						</dd>

						<dt className="col-sm-5">
							{t('CityOfBirth', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.cityOfBirth}
						</dd>

						<dt className="col-sm-5">
							{t('Nationality', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.nationality}
						</dd>

						<dt className="col-sm-5">
							{t('Gender', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.gender}
						</dd>

						<dt className="col-sm-5">
							{t('MaritalStatus', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.maritalStatus}
						</dd>

						<dt className="col-sm-5">
							{t('Citizenship', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.citizenship?.join(
								', ',
							)}
						</dd>

						<dt className="col-sm-5">
							{t('CountryOfBirth', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.countryOfBirth}
						</dd>

						<dt className="col-sm-5">
							{t('Title', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.personalInfo?.title}
						</dd>
					</dl>
				</div>

				<div className="data-section col-12 col-md-6 mb-4">
					<h4>{t('AddressHeader')}</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('Street', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.street}
						</dd>

						<dt className="col-sm-5">
							{t('StreetNumber', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.streetNumber}
						</dd>

						<dt className="col-sm-5">
							{t('City', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.city}
						</dd>

						<dt className="col-sm-5">
							{t('Zip', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.zip}
						</dd>

						<dt className="col-sm-5">
							{t('CountryOfResidence', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.countryOfResidence}
						</dd>

						<dt className="col-sm-5">
							{t('FlatNumber', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.flatNumber}
						</dd>

						<dt className="col-sm-5">
							{t('TimeAtAddress', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.timeAtAddress}
						</dd>

						<dt className="col-sm-5">
							{t('BuildingName', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.address?.buildingName}
						</dd>
					</dl>
				</div>

				<div className="data-section col-12 col-md-6 mb-4">
					<h4>{t('FormerAddressHeader')}</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('Street', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.street}
						</dd>

						<dt className="col-sm-5">
							{t('StreetNumber', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.streetNumber}
						</dd>

						<dt className="col-sm-5">
							{t('City', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.city}
						</dd>

						<dt className="col-sm-5">
							{t('Zip', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.zip}
						</dd>

						<dt className="col-sm-5">
							{t('Country', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.country}
						</dd>

						<dt className="col-sm-5">
							{t('FlatNumber', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.flatNumber}
						</dd>

						<dt className="col-sm-5">
							{t('BuildingName', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.formerAddress?.buildingName}
						</dd>
					</dl>
				</div>

				<div className="data-section col-12 col-md-6 mb-4">
					<h4>{t('ContactInfoHeader')}</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('MobilePhoneNo', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.contacts?.cellPhone}
						</dd>

						<dt className="col-sm-5">
							{t('Email', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.contacts?.email}
						</dd>
					</dl>
				</div>

				<div className="data-section col-12 col-md-6 mb-4">
					<h4>{t('AccommodationHeader')}</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('AccommodationCost', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.accommodation?.cost}
						</dd>

						<dt className="col-sm-5">
							{t('AccommodationType', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.accommodation?.type}
						</dd>

						<dt className="col-sm-5">
							{t('ChildrenInFamily', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.accommodation?.childrenInFamily}
						</dd>

						<dt className="col-sm-5">
							{t('ChildcareCost', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.accommodation?.childcareCost}
						</dd>
					</dl>
				</div>

				<div className="data-section col-12 col-md-6 mb-4">
					<h4>
						{t('EmploymentAndIncomeHeader', {
							ns: TranslationFile.Forms,
						})}
					</h4>
					<hr />
					<dl className="row">
						<dt className="col-sm-5">
							{t('MonthlyIncome', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.monthlyNetIncome}
						</dd>

						<dt className="col-sm-5">
							{t('OtherIncome', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.otherIncome}
						</dd>

						<dt className="col-sm-5">
							{t('Occupation', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.occupationType}
						</dd>

						<dt className="col-sm-5">
							{t('EmployerName', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.employerName}
						</dd>

						<dt className="col-sm-5">
							{t('EmployedSince', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.employedSince
								? new Date(
										applicationData.employment
											.employedSince!,
									).toLocaleDateString(getLanguageLocale())
								: ''}
						</dd>

						<dt className="col-sm-5">
							{t('JobTitle', { ns: TranslationFile.Forms })}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.jobTitle}
						</dd>

						<dt className="col-sm-5">
							{t('EmploymentSector', {
								ns: TranslationFile.Forms,
							})}
						</dt>
						<dd className="col-sm-7">
							{applicationData?.employment?.employmentSector}
						</dd>
					</dl>
				</div>
			</div>

			<div className="d-flex justify-content-center mt-4">
				<button
					className="btn btn-outline-deep-green mx-2"
					onClick={() => setShowModal(true)}>
					{t('EditData')}
				</button>
				<button
					className="btn btn-primary mx-2"
					onClick={handleContinue}>
					{t('ContinueWithoutEditing')}
				</button>
			</div>

			<Modal
				show={showModal}
				onHide={() => setShowModal(false)}
				backdrop="static"
				animation={false}>
				<Modal.Header>
					<Modal.Title>{t('ConfirmEditHeader')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{t('ConfirmEditDescription')}</p>
					<p>{t('ConfirmEditDescriptionLine2')}</p>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-primary"
						onClick={handleEditConfirm}>
						{t('ChangeDataBtn')}
					</button>
					<button
						className="btn btn-outline-deep-green mt-2"
						onClick={() => setShowModal(false)}>
						{t('ContinueWithoutChangingBtn')}
					</button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default ApplicationDataViewUk
